import { render, staticRenderFns } from "./auth_phone.vue?vue&type=template&id=d7ce5234&scoped=true"
import script from "./auth_phone.vue?vue&type=script&lang=js"
export * from "./auth_phone.vue?vue&type=script&lang=js"
import style0 from "./auth_phone.vue?vue&type=style&index=0&id=d7ce5234&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ce5234",
  null
  
)

export default component.exports